import { render } from "./HomepageRecommendationsCarousel.vue?vue&type=template&id=15cd0ba0"
import script from "./HomepageRecommendationsCarousel.vue?vue&type=script&lang=js"
export * from "./HomepageRecommendationsCarousel.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__